import {FC, useState} from 'react';
import Button from '@/shared/components/Button';
import {Box, Typography} from '@mui/material';
import {BODY2, SUBTITLE1} from '@/utils/constants';
import {ReactComponent as ZappierIcon} from '@icons/zappier-icon.svg';
import {ReactComponent as ZappierActiveIcon} from '@icons/zappier-active-icon.svg';
import {integrationStyle} from './Integration.styles';

const Integration: FC = () => {
	const [isConnected, setIsConnected] = useState(false);

	return (
		<Box sx={integrationStyle.wrapperContainer}>
			<Box sx={integrationStyle.wrapper}>
				<Box sx={integrationStyle.iconWrapper}>
					<Box sx={integrationStyle.icon}>
						<ZappierActiveIcon />
					</Box>
					<Typography sx={integrationStyle.title} variant={SUBTITLE1}>
						Zappier
					</Typography>
				</Box>

				<Typography sx={integrationStyle.afterTitle} variant={BODY2}>
					Use Zapier to connect EventSimpli with 1,000+ tools like QuickBooks and Salesforce and automate everyday tasks
				</Typography>
				<Button
					startIcon={<ZappierIcon />}
					sx={integrationStyle.button}
					title={isConnected ? 'Disconnect Zapier' : 'Connect Zapier'}
					onClick={() => setIsConnected((prev) => !prev)}
				/>
			</Box>
		</Box>
	);
};

export default Integration;
